interface ReturnFareFreeCalendarVisibilityParams {
  hasReturnFareFree?: boolean
  isEconomy?: boolean
}

export function shouldShowReturnFareFreeCalendarLabel({
  hasReturnFareFree,
  isEconomy = true,
}: ReturnFareFreeCalendarVisibilityParams): boolean {
  return !!hasReturnFareFree &&
    isEconomy
}
